import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { withAsyncBoundary } from '@toss/async-boundary';
import cns from 'classnames';
import { useSpaceCategories } from '@zep/apis';
import { SpaceCategory } from '@zep/types';
import { cn } from '@zep/utils';
import { TemplateFilterBanner } from './TemplateFilterBanner';
interface TemplateFilterProps extends Record<string, unknown> {
  selectedCategoryId: number;
  onCategoryChange: (categoryId: number) => void;
  isPurchasedView?: boolean;
}
const TemplateFilterContent = ({
  selectedCategoryId,
  onCategoryChange,
  isPurchasedView = false
}: TemplateFilterProps) => {
  const {
    i18n,
    t
  } = useTranslation(['common']);
  const {
    data: {
      categories
    }
  } = useSpaceCategories({
    locale: i18n.resolvedLanguage ?? 'en'
  });
  const categoriesWithAll = useMemo<SpaceCategory[]>(() => [{
    id: -1,
    category: t('common:space.category.all'),
    visible: true,
    priority: 0,
    prefixIcon: '🌐'
  }, ...categories.filter(category => category.visible && category.id !== 8 // 기타 카테고리(id: 8) 제외
  )], [categories, t]);
  return <div className={cn('w-[200px]', isPurchasedView ? 'opacity-40 pointer-events-none' : 'opacity-100')} data-sentry-component="TemplateFilterContent" data-sentry-source-file="TemplateFilter.tsx">
      <div className="overflow-hidden rounded-[12px] bg-white shadow-[0_1px_4px_0_rgba(42,39,65,0.08)]">
        <div className="p-[8px] pt-[12px]">
          {categoriesWithAll.map(category => <button key={category.id} onClick={() => onCategoryChange(category.id)} className={cns('w-full flex items-center px-4 py-3 text-[13px] font-medium leading-[140%] rounded-[4px] text-left transition-all duration-200', 'hover:bg-[#F8F9FC]', {
          'bg-[#F3F2FF] text-[#5748F2]': selectedCategoryId === category.id,
          'text-[#5D5E69] hover:text-gray-900': selectedCategoryId !== category.id
        })}>
              {category.prefixIcon && <span className="mr-3 text-lg">{category.prefixIcon}</span>}
              <span>{category.category}</span>
            </button>)}
        </div>
      </div>

      <TemplateFilterBanner data-sentry-element="TemplateFilterBanner" data-sentry-source-file="TemplateFilter.tsx" />
    </div>;
};
export const TemplateFilter = withAsyncBoundary<TemplateFilterProps>(TemplateFilterContent, {
  pendingFallback: <div className="w-full">
        <div className="animate-pulse overflow-hidden rounded-[8px] bg-white shadow-sm">
          <div className="border-b border-gray-100 px-5 py-4">
            <div className="h-5 w-24 rounded bg-gray-200"></div>
          </div>
          <div className="space-y-2 p-3">
            {[...Array(6)].map((_, i) => <div key={i} className="h-10 rounded-[8px] bg-gray-100"></div>)}
          </div>
        </div>
      </div>,
  rejectedFallback: () => null
});